module.exports = __webpack_public_path__ + "img/video4.04949b0b.png";